// <s-copy-code> copies the text of its [data-code] element when a button sends the --copy command.
class SCopyCode extends HTMLElement {
  #ac;
  #rafId = 0;
  #resetTimer = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => this.#onCommand(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#rafId);
    clearTimeout(this.#resetTimer);
  }

  async #onCommand(event) {
    if (event.command !== '--copy') return;
    const code = this.querySelector('[data-code]')?.textContent.trim();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      return;
    }
    const status = this.querySelector('[data-copy-status]');
    const message = this.dataset.copiedMessage || '';
    if (status) {
      cancelAnimationFrame(this.#rafId);
      status.textContent = '';
      this.#rafId = requestAnimationFrame(() => {
        status.textContent = message;
      });
    }
    this.toggleAttribute('data-copied', true);
    clearTimeout(this.#resetTimer);
    this.#resetTimer = setTimeout(() => this.removeAttribute('data-copied'), 2000);
  }
}

if (!customElements.get('s-copy-code')) customElements.define('s-copy-code', SCopyCode);
